export default function About() {
  return (
    <section id="about" className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
        <div className="mb-12 sm:mb-16 text-center animate-fade-in-up">
          <span className="inline-block bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 text-sm font-semibold px-5 py-2 rounded-full mb-4">
            自己紹介思い
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500 tracking-tight mb-4 sm:mb-6">
            私の想い
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg p-6 sm:p-10 lg:p-12 shadow-lg border border-purple-100 animate-fade-in-up" style={{ animationDelay: '200ms' }}>
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 sm:gap-8 mb-8">
              <div className="flex-shrink-0">
                <img 
                  src="https://public.readdy.ai/ai/img_res/55c0c07c66c001b5c7e6bf0dee44721f.jpg" 
                  alt="木村ま誇(KIMURAMA)" 
                  className="w-32 h-32 sm:w-40 sm:h-40 rounded-full object-cover border-4 border-white shadow-lg"
                />
              </div>
              <div className="text-center sm:text-left flex-1">
                <p className="text-base sm:text-lg font-medium text-purple-700 mb-3">
                  KIMURAMA WORKS代表
                </p>
                <img 
                  src="https://static.readdy.ai/image/d367af92f7f38cbe19d536434073c925/8327e61295be687fcc64ed6d5fbf7631.png"
                  alt="木村ま誇(KIMURAMA)"
                  className="h-12 w-auto mx-auto sm:mx-0 mb-3 object-contain"
                />
                <p className="text-base sm:text-lg font-medium text-purple-700 mb-3">
                  AIコンサルタント / AIライター / AIクリエイター
                </p>
                <p className="text-base sm:text-lg font-semibold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
                  AIでAI(アイ＝愛)ある新しい世界を創造する
                </p>
              </div>
            </div>

            <div className="space-y-6 text-base sm:text-lg leading-relaxed text-purple-900">
              <div className="bg-white/60 rounded-lg p-6 border border-purple-100">
                <h4 className="text-xl font-semibold text-purple-900 mb-4">
                  私の想い
                </h4>
                <p className="mb-4">
                  人が仕事や暮らしの中で抱える悩みは、忙しさによって時間や心の余裕が削られてしまうところから生まれることが多いと感じています。AIは効率化だけでなく、本来の力を取り戻すための支えにもなり、一人ひとりの可能性にそっと光をあててくれる存在だと考えています。
                </p>
                <p className="mb-4">
                  企業でもAI活用が新しい変化を生む場面が増え、小さな工夫が働く人の負担を和らげたり、組織の前進につながることがあります。安心して相談できる相手がそばにいることで、挑戦がしやすくなり、見えてくる選択肢も広がっていきます。
                </p>
                <p>
                  AIと共に進む過程で生まれる気づきや成長を、必要な場面で静かに支えられる存在でありたいと考えています。歩幅を合わせながら進む中で、その人や企業らしい未来が育っていくことを大切にしています。
                </p>
              </div>

              <div className="bg-white/60 rounded-lg p-6 border border-purple-100">
                <h4 className="text-xl font-semibold text-purple-900 mb-4 flex items-center gap-2">
                  <i className="ri-briefcase-fill text-purple-500"></i>
                  経歴・実績
                </h4>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-purple-500 mt-1 flex-shrink-0"></i>
                    <span>toB・toCともにAI導入支援コンサルティングを実施</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-purple-500 mt-1 flex-shrink-0"></i>
                    <span>AIセミナー講師として受講生500人以上をサポート</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-purple-500 mt-1 flex-shrink-0"></i>
                    <span>AIツールを活用したコンテンツ制作実績100件以上</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-purple-500 mt-1 flex-shrink-0"></i>
                    <span>SNS運用支援で企業のフォロワー増加、収益化支援</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white/60 rounded-lg p-6 border border-purple-100">
                <h4 className="text-xl font-semibold text-purple-900 mb-4">
                  得意分野
                </h4>
                <div className="flex flex-wrap gap-2">
                  <span className="bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
                    AI導入支援
                  </span>
                  <span className="bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
                    業務効率化
                  </span>
                  <span className="bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
                    コンテンツ制作
                  </span>
                  <span className="bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
                    SNS戦略
                  </span>
                  <span className="bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
                    ChatGPT活用
                  </span>
                  <span className="bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
                    プロンプト設計
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}